import styled from 'styled-components';

export const KPICardWrapper = styled.div`
    width: 150px;
    height: 150px;
    border-radius: 8px;
    margin: 1%;
    padding: 1%;
    text-align: center;
    background-color: ${props => props.isTotal ? props.theme.evTeal : props.theme.ecoMint};
    color: ${props => props.isTotal ? 'white' : props.theme.voltBlue};

    @media only screen and (max-width: 600px) {
        width: 100%;
    }
`;

export const MiddleWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    align-self: center;
    width: 150px;
    height: 150px;
    @media only screen and (max-width: 600px) {
        width: 100%;
    }
`;

export const RemoveButton = styled.button`
    background: none;
    border: none;
    color: ${props => props.theme.voltBlue};
    cursor: pointer;
    font-size: 1rem;
    margin-top: 5px;
    justify-content: right;

    &:hover {
        color: red;
    }
`;

export const ButtonWrapper = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: space-around;
    height: 0px;
    text-align: right;
`;

export const KPINumber = styled.div`
    font-size: 1.5rem;
    font-weight: bold;
    margin-bottom: 5px;
`;